import { Component, Input } from '@angular/core';

@Component({
  selector: 'ff-cta-button',
  templateUrl: './cta-button.component.html',
  styleUrls: ['./cta-button.component.scss']
})
export class CtaButtonComponent {

  /**
   * Class so the parent can decide the color scheme
   */
  @Input() color: string = "red";

  /**
   * Text to be display in the button
   * @internal
   */

  @Input() displayText: string;

  /**
   * This function will be call when the user click the button,
   * the button will emit the entire html event to be handle
   * in the parent component.
   * @internal
   */

  @Input() onClick: Function;

  /**
   * Allow the user the option to disable the button
   * Default value: false
   * @internal
   */

  @Input() isDisabled: boolean = false;

  constructor() { }

  submit = (event: Event): void => {
    this.onClick(event);
  }

}
